<template>
	<div class="footerNav">
		<div class="footer1">
			<b-container class="bv-example-row">
				<b-row>
					<!-- 产品展示 -->
					<b-col class="col" cols="2">
						<!--  left clear -->
						<div class="footers footShow">
							<span>产品展示</span>
							<div class="clear">
								<div class="showLeft left">
									<p style="padding-top: 22px;">分类目录</p>
									<ul>
										<li v-for="(current,i) in bdataList">
											<!-- <a href="javascript:void(0)" @click="toView('/simple?go=simple', 'simple')">{{current.name}}</a> -->
											<a href="javascript:void(0)" @click="goSimple('simple', current.id,'1',current.name)">{{current.name}}</a>
											<!-- <router-link to="/simple">智能锁</router-link> -->
										</li>
									</ul>
								</div>
								<div class="showRight left">
									<p style="padding-top: 22px;">款式</p>
									<ul>
										<li v-for="(current,i) in sdataList">
											<!-- <a href="javascript:void(0)" @click="toView('/simple?go=simple', 'simple')">{{current.name}}</a> -->
											<a href="javascript:void(0)" @click="goSimple('simple', current.name,'2')">{{current.name}}</a>
											<!-- <router-link to="/simple">简约</router-link> -->
										</li>
									</ul>
								</div>
							</div>
						</div>
					</b-col>
					<!-- 应用 -->
					<b-col class="colLeft">
						<span>应用</span>
						<p>
							<ul>
								<li>
										<a href="javascript:void(0)" @click="toView('/application?go=application', 'application')">酒店应用</a>
								<!-- 	<router-link to="/application">酒店应用</router-link> -->
								</li>

							</ul>
						</p>
					</b-col>
					<!-- 应用 -->
					<b-col class="colLeft" style="margin-left: 0px;">
						<span>定制</span>
						<p>
							<ul>
								<li>
									<a href="javascript:void(0)" @click="toView('/applicationTwo?go=applicationTwo', 'applicationTwo')">产品定制</a>
									<!-- <router-link to="/applicationTwo">产品定制</router-link> -->
								</li>

							</ul>
						</p>
					</b-col>

					<!-- 探索与发现 -->
					<b-col class="colLeft" style="margin-left: 0px;">
						<span>探索与发现</span>
						<p>
							<ul>
								<li>
									<a href="javascript:void(0)" @click="toView('/industryNews?go=industryNews', 'industryNews')">行业资讯</a>
									<!-- <router-link to="/industryNews">行业资讯</router-link> -->
								</li>
								<li>
									<a href="javascript:void(0)" @click="toView('/companyNews?go=companyNews', 'companyNews')">公司动态</a>
									<!-- <router-link to="/companyNews">公司动态</router-link> -->
								</li>
								<li>
									<a href="javascript:void(0)" @click="toView('/newProduct?go=newProduct', 'newProduct')">新品发布</a>
									<!-- <router-link to="/newProduct">新品发布</router-link> -->
								</li>
							</ul>
						</p>
					</b-col>
					<!-- 资料下载 -->
					<b-col class="colLeft">
						<span>资料下载</span>
						<!-- <span><a href="javascript:void(0)">资料下载</a></span> -->
						<p>
							<ul>
								<li>
									<a href="javascript:void(0)" @click="toView('/installation?go=installation', 'installation')">安装说明书</a>
									<!-- <router-link to="/installation">安装说明书</router-link> -->
								</li>
								<li>
									<a href="javascript:void(0)" @click="toView('/clean?go=clean', 'clean')">保养和清洁</a>
									<!-- <router-link to="/clean">保养和清洁</router-link></a> -->
								</li>
								<li>
									<a href="javascript:void(0)" @click="toView('/questions?go=questions', 'questions')">常见问题</a>
									<!-- <router-link to="/questions">常见问题</router-link> -->
								</li>
								<li>
									<a href="javascript:void(0)" @click="toView('/picture?go=picture', 'picture')">画册下载</a>
									<!-- <router-link to="/picture">画册下载</router-link> -->
								</li>
							</ul>
						</p>
					</b-col>
					<!-- 关于我们 -->
					<b-col class="colLeft">
						<span>关于我们</span>
						<p>
							<ul>
								<li>
									<!-- <router-link to="/aboutUs">公司简介</router-link> -->
									<a href="javascript:void(0)" @click="toView('/aboutUs?go=aboutUs', 'aboutUs')">公司简介</a>
								</li>
								<li>
									<a href="javascript:void(0)" @click="toView('/aboutUs?go=doIt', 'doIt')">工艺流程</a>
									<!-- <router-link to=""></router-link> -->
								</li>
							</ul>
						</p>
					</b-col>
					<!-- 联系 -->
					<b-col class="colLeft">
						<span>联系</span>
						<p>
							<ul>
								<li>
									<a href="javascript:void(0)" @click="toView('/findDealer?go=findDealer', 'findDealer')">寻找经销商</a>
									<!-- <router-link to="/findDealer">寻找经销商</router-link> -->
								</li>
								<li>
									<a href="javascript:void(0)" @click="toView('/contact?go=contact', 'contact')">联系方式</a>
									<!-- <router-link to="/contact">联系方式</router-link> -->
								</li>
							</ul>
						</p>
					</b-col>
				</b-row>
			</b-container>
		</div>

		<!-- 尾部公司名和联系方法 -->
		<div class="footer2">
			<div class="footerBar">
				<b-container class="bv-example-row">
					<b-row>
						<b-col class="footCenter footTitle" sm="12" md="3" lg="3" cols="12">瀚佰锐装饰五金有限公司</b-col>
						<b-col class="footCenter footerNum numOne" sm="4" md="2" lg="2">T/0750-6107993/6107965</b-col>
						<b-col class="footCenter footerNum" sm="4" md="2" lg="2">F/0750-6107998/6107963</b-col>
						<b-col class="footCenter footerNum" sm="4" md="2" lg="2">E/xhtf_0750@163.com</b-col>
						<b-col class="footCenter footerNum" sm="12" md="3" lg="3" cols="12">A/广东省江门市新会区都会过海围工业区18号</b-col>
					</b-row>
				</b-container>
				<div class="yueNum" style="font-size: 14px;text-align: center;"><p style="margin-bottom: 0;padding: 2px 0 8px 0;"><a href="http://beian.miit.gov.cn/"  target="_blank">粤ICP备20069229号</a></p></div>
			</div>
			
		</div>
	</div>
</template>

<script>
	export default {
		name: "myFooter",
		data() {
			return {
				bdataList :[],
				sdataList :[]
			}
		},
		mounted() {
			this.getBigCatalogData();
			this.getSmallCatalogData();
		},
		methods: {
			toView(path, goId) {
				if (this.$route.fullPath != path) {
					this.$router.push(path)
				} else {
					document.querySelector("#" + goId).scrollIntoView(true)
				}
			},
			getBigCatalogData(){
				let that = this;
				that.$axios.get(that.$global.baseURL + '/web/productListCatalog/getCatalogBigData.form').then(res => {
					if (res.data.jsonArray == 'error') {
						uni.showModal({
							title: res.data.errorInfo,
							showCancel: false
						});
					} else {
						that.bdataList = res.data.dataList;
					}
				});
			},
			getSmallCatalogData(){
				let that = this;
				that.$axios.get(that.$global.baseURL + '/web/productListCatalog/getCatalogSmallData.form').then(res => {
					if (res.data.jsonArray == 'error') {
						uni.showModal({
							title: res.data.errorInfo,
							showCancel: false
						});
					} else {
						that.sdataList = res.data.dataList;
					}
				});
			},
			goSimple(path, goId, type,name) {
				let that = this;
				let arr = {
					parentId: "",
					catalogName: "",
					type: type
				}
				if (type == "1") {
					arr.parentId = goId;
					arr.catalogName = name;
				} else {
					arr.parentId = "";
					arr.catalogName = goId;
				}
				if (that.$route.path != path) {
					// 跳转页面
					this.$router.push({
						path: '/simple',
						query: {
							parentId: arr.parentId,
							catalogName: arr.catalogName,
							type:type
						}
					})
					document.body.scrollTop = 0; 
					document.documentElement.scrollTop = 0;
				} else {
					document.querySelector("#" + goId).scrollIntoView(true)
				}
			},
		}
	}
</script>

<style>
	.yueNum a{
		color: #8D8C8C;
	}
	
	.yueNum a:hover{
		color: #ff8060;
		cursor: pointer;
	}
	
	.bv-example-row {
		text-align: left;
		width: 100%;
	}

	.footer1 {
		margin-top: 20px;
		padding-top: 20px;
		margin-bottom: 60px;
		/* max-width:1340px; */
		/* margin: 0 auto; */
		border-top: 1px solid #C4C4C4;
	}

	.footer1 .row {
		margin-left: 23px;
	}

	.footer1 .row .col {
		/* 
		border: 1px solid red; */
	}


	.footer1 .row .colLeft {
		margin-left: 26px;
	}

	.footShow ul li {
		list-style-type: none;
		font-size: 14px;
		color: #595757;
		padding: 4px 0 4px;
		margin-left: 0 !important;
	}

	.footer1 .showRight {
		margin-left: 20%;
	}

	.footer1 span {
		font-size: 20px;
		color: #595757;
	}

	.footer1 a {
		color: #595757;
		text-decoration: none;
	}

	.footer1 a:hover {
		color: #303133;
	}

	.footers p {
		font-size: 16px;
		color: #595757;
		font-weight: bold;
		padding-top: 15px;
	}

	/* .col .colpleft {
		margin-left: 20px;
	} */

	.col p {
		font-size: 16px;
		color: #595757;
		padding-top: 15px;
	}

	.footer1 ul li {
		list-style: none;
		font-size: 14px;
		color: #595757;
		padding-top: 8px;
	}

	.footer2 {
		margin-top: 10px;
		margin-bottom: 50px;
		padding: 5px 0;
		border-top: 1px solid #C4C4C4;
		border-bottom: 1px solid #C4C4C4;
	}

	.footerBar .footCenter {
		/* border: 1px solid red; */
		/* text-align: center; */
	}

	.footerBar .footTitle {
		font-size: 18px;
		/* font-weight: bold; */
		color: #595757;
		padding: 10px 0px;
	}

	.footerBar .footerNum {
		color: #8D8C8C;
		padding: 10px 0px;
		font-size: 14px;
	}

	.footerBar .footerNum .numOne {
		margin-left: -45px;
	}

	@media (min-width: 1600px) {

		.footer1 .container,
		.container-sm,
		.container-md,
		.container-lg,
		.container-xl {
			max-width: 1600px;
		}
	}

	/* @media (min-width: 1600px) {
		.footer1 {
			max-width: 1600px;
		}
	} */

	@media screen and (max-width: 991px) {
		.footer1 {
			display: none !important;
			border: none;
		}
	}

	@media screen and (max-width: 576px) {
		.footCenter {
			text-align: center;
		}
	}
</style>
